import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "confirmacion-app-icon-wrap" };
const _hoisted_2 = { class: "confirmacion-app-mensaje" };
const _hoisted_3 = {
    key: 0,
    class: "confirmacion-app-detalle"
};
const _hoisted_4 = {
    key: 1,
    class: "confirmacion-app-prompt mb-3"
};
const _hoisted_5 = { class: "form-label small fw-semibold mb-1" };
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = { class: "confirmacion-app-actions" };
const _hoisted_8 = ["disabled"];
import { computed } from "vue";
import { cerrarConfirmacion, confirmacionState, confirmarPrompt, getConfirmacionEstilos, } from "@/composables/confirmacionApp";
const tituloId = "confirmacion-app-titulo";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfirmacionAppModal',
    setup(__props) {
        const state = confirmacionState;
        const estilos = computed(() => getConfirmacionEstilos(state.variante));
        const confirmDisabled = computed(() => state.modo === "prompt" &&
            state.promptRequired &&
            !state.promptValue.trim());
        const cancelar = () => {
            cerrarConfirmacion(false);
        };
        const aceptar = () => {
            if (state.modo === "prompt") {
                confirmarPrompt();
                return;
            }
            cerrarConfirmacion(true);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (_unref(state).visible)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "confirmacion-app-backdrop",
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-labelledby": tituloId,
                        onClick: _withModifiers(cancelar, ["self"])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["confirmacion-app-dialog", `confirmacion-modulo-${_unref(state).modulo}`])
                        }, [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(["bi confirmacion-app-icon", [_unref(state).icono, estilos.value.iconClass]]),
                                    "aria-hidden": "true"
                                }, null, 2)
                            ]),
                            _createElementVNode("h5", {
                                id: tituloId,
                                class: "confirmacion-app-titulo"
                            }, _toDisplayString(_unref(state).titulo), 1),
                            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(state).mensaje), 1),
                            (_unref(state).detalle)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(state).detalle), 1))
                                : _createCommentVNode("", true),
                            (_unref(state).modo === 'prompt')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(state).promptLabel || "Comentario"), 1),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(state).promptValue) = $event)),
                                        class: "form-control form-control-sm",
                                        rows: "3",
                                        placeholder: _unref(state).promptPlaceholder
                                    }, null, 8, _hoisted_6), [
                                        [_vModelText, _unref(state).promptValue]
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_7, [
                                (_unref(state).modo !== 'alert')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-outline-secondary",
                                        onClick: cancelar
                                    }, _toDisplayString(_unref(state).textoCancelar), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["btn", estilos.value.btnClass]),
                                    disabled: confirmDisabled.value,
                                    onClick: aceptar
                                }, _toDisplayString(_unref(state).textoConfirmar), 11, _hoisted_8)
                            ])
                        ], 2)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
